import { PersonAvatar } from '@/components/PersonAvatar';
import { AvatarGroup, AvatarGroupCount } from '@/components/ui/avatar';
import type { WorkItem } from '../types';

type Assignee = NonNullable<WorkItem['assignee_details']>[number];

/** Overlapping assignee avatars (photo or initials), capped with a +N pill. */
export function AssigneeAvatars({
  assignees,
  size = 'sm',
  max = 3,
}: {
  assignees: Assignee[] | undefined;
  size?: 'sm' | 'default';
  max?: number;
}) {
  if (!assignees || assignees.length === 0) return null;
  const shown = assignees.slice(0, max);
  const extra = assignees.length - shown.length;
  return (
    <AvatarGroup>
      {shown.map((a) => (
        <PersonAvatar key={a.id} name={a.name} photo={a.photo} size={size} />
      ))}
      {extra > 0 ? <AvatarGroupCount>+{extra}</AvatarGroupCount> : null}
    </AvatarGroup>
  );
}
